export const featureKey = 'genesysCloudWorkItemIntegrations';
